import React from 'react';
import stilePulsanti from '../../../interfaccia/stilePulsanti';

function BarraBrands({
    elemento,
    creaNuovoElemento,
    apriElemento,
    mobile,
    utente,
    filterText,
    setFilterText,
    togliTastoNuovo
}) {
  
    //TODO AGGIUNGERE RICERCA CON FILTRI COME INDICATO IN https://react-data-table-component.netlify.app/?path=/docs/examples-filtering--filtering

    const handleChange = async function (evt) {
        const value = evt.target.value;
        try {
            setFilterText(value);
        } catch (err) {
            console.log("Errore nell'aggiornamento di un dato non nestato: " + err)
            throw err;
        }
    }


  return (
    <div className={'formRicercaOrizzontale pb2 flex justify-between items-center'}>
        {!togliTastoNuovo && utente.permessiAPI["update:database"] && <div className='dim pointer gruppoInputRicercaOrizzontale mr2' onClick={creaNuovoElemento}>
                    <button className=" tastoInputOrizzontale br3">{stilePulsanti.tastoNuovoAspetto}</button>
                    <span className='ml2 nonSelezionabile'>NUOVO</span>
                </div>}
        <div className='gruppoInputRicercaOrizzontale'>
                <label className='mr1 b nonSelezionabile' for="filterText">Nome</label>
                <input
                    value={filterText}
                    name="filterText"
                    onChange={handleChange}
                    id="filterText"
                    className="input-reset inputOrizzontale"
                    type="text"
                    aria-describedby="name-desc"
                    autoComplete="off" />
            </div> 
    </div>
  )
}

export default BarraBrands;